import { DataBean } from "../DataBean";

export class RawMaterialRequestCatalog extends DataBean {


    public async getRawMaterialRequestCatalog(idProductionOrder:any,productionOrderDate:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getRawMaterialRequestCatalog_Number_java.util.Date", [idProductionOrder,productionOrderDate]);
    }


 
}